'use strict';

var inputClassFactory = require('./inputClassFactory');
var compose = require('../hoc/compose');
var withValidation = require('../hoc/withValidation');
var template = require('./textInput.rt');
var displayNames = require('./displayNames');

module.exports = compose(inputClassFactory(displayNames.TEXT_INPUT, template), [withValidation]);


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/textInput.js